import { ClientEvent, SyncState } from 'matrix-js-sdk';
import { Log } from '@fanfanlo';
import { roomService } from '../roomService';
import { matrixClient } from '../../client';

const fileLogger = new Log(false, 'im.client.room.handlers.sync');
fileLogger.childrenPaused = true;
let prepared = false;

async function onClientSync(state: SyncState, prevState: SyncState | null) {
    const logger = fileLogger.sub(false, 'onClientSync');
    logger.pause = true;
    logger.log(`Sync state changed: ${prevState || 'None'} -> ${state}`);

    if (state === SyncState.Prepared && !prepared) {
        prepared = true;
        await onPrepared();
    }
}

async function onPrepared() {
    const logger = fileLogger.sub(false, 'onPrepared');
    logger.pause = true;
    logger.log('Client SyncState is Prepared. Loading initial room list...');
    
    if (!matrixClient.client) {
        logger.error("Matrix client is not available in onPrepared.");
        return;
    }

    try {
        const rooms = await matrixClient.client.getRooms();
        logger.log(`Found ${rooms.length} rooms`);
        
        // 初始化已加入的房间
        for (const room of rooms) {
            if (room.getMyMembership() === 'join') {
                const client = matrixClient.client;
                const avatarUrl = room.getAvatarUrl(client.getHomeserverUrl(), 32, 32, 'scale', false, false) || undefined;
                
                roomService.addJoinedRoom(room.roomId);
                roomService.addOrUpdateRoomInfo({
                    roomId: room.roomId,
                    name: room.name,
                    membership: 'join',
                    avatarUrl
                });
            }
        }
    } catch (error) {
        logger.error('Failed to load rooms:', error);
    }
}

export const syncHandler = {
    init() {
        matrixClient.clientOnEventDispatcher.addListener(ClientEvent.Sync, onClientSync);
    }
};
